import { useCallback, useEffect, useMemo } from 'react';
/**
 * useFocus - A hook that manages focus behavior for a given ref and focus state.
 *
 * It accepts an optional callback functions:
 * - `handleOnFocus` - callback function to be called when the element is focused.
 * - `handleOnBlur` - callback function to be called when the element loses focus.
 */

export var useFocus = _ref => {
  var {
    ref,
    isFocused,
    handleOnFocus,
    handleOnBlur
  } = _ref;
  var shouldFocusRef = useMemo(() => isFocused && ref.current !== document.activeElement, [ref, isFocused]);
  useEffect(() => {
    if (!ref.current) return;

    if (shouldFocusRef) {
      ref.current.focus();
    }
  }, [ref, shouldFocusRef]);
  var onFocus = useCallback(e => {
    if (handleOnFocus) {
      e.preventDefault();
      handleOnFocus === null || handleOnFocus === void 0 ? void 0 : handleOnFocus();
    }
  }, [handleOnFocus]);
  var onBlur = useCallback(e => {
    if (handleOnBlur) {
      e.preventDefault();
      handleOnBlur === null || handleOnBlur === void 0 ? void 0 : handleOnBlur();
    }
  }, [handleOnBlur]);
  return {
    onBlur,
    onFocus
  };
};
//# sourceMappingURL=useFocus.js.map